import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'

import HelperText from './HelperText'
import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    //marginTop: theme.spacing(2),
  },
}))

const SelectField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    field: {
      name,
      value,
      onChange,
    },
    disabled,
    error,
    touched,
    item,
    readonly,
  } = getProps(props)
  const classes = useStyles()
  const title = item.title || name

  return (
    <FormControl component="fieldset" className={ classes.root } disabled={ disabled } error={ error ? true : false }>
      <InputLabel htmlFor={ name }>{ title }</InputLabel>
      <Select
        value={ value || '' }
        disabled={ readonly }
        onChange={ onChange }
        inputProps={{
          name,
          id: name,
        }}
      >
        {
          (item.options || []).map((option, i) => {
            option = typeof(option) === 'string' ? {
              title: option,
              value: option,
            } : option

            return (
              <MenuItem
                key={ i }
                value={ option.value }
              >
                { option.title }
              </MenuItem>
            )
          })
        }
      </Select>
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )
}

export default SelectField